var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Stack } from "@mui/material";
import React from "react";
import { PrintSvgIcon, ShareLineSvgIcon } from "../../../assets/customIcons";
import { SavedSuccessGreenTickCircle } from "../../../assets/images";
import { ReactComponent as CloseIcon } from '../../../assets/images/closeIcon.svg';
import { DynamicFormBuilderContainer } from "../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.container";
import { FormItemTypes } from "../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity";
import { useAppSelector } from "../../../store/hooks";
import { JobCardInvoicesKeys } from "../services/entity";
export var JCInvoiceSaveSuccessfullpopup = function (_ref) {
    var _crud$JobCardInvoices, _totals$TotalDiscount;
    var data = _ref.data, onClose = _ref.onClose;
    var crud = useAppSelector(function (state) { return state.crud; });
    var totals = data === null || data === void 0 ? void 0 : data.reduce(function (acc, item) {
        acc.TotalTax += item.TotalTax || 0;
        acc.TotalDiscount += item.TotalDiscount || 0;
        acc.PaidAmount += item.PaidAmount || 0;
        acc.ExpenseAmount += item.ExpenseAmount || 0;
        acc.ClaimAmount += item.ClaimAmount || 0;
        acc.GrandTotal += item.GrandTotal || 0;
        return acc;
    }, {
        TotalTax: 0,
        TotalDiscount: 0,
        PaidAmount: 0,
        ExpenseAmount: 0,
        ClaimAmount: 0,
        GrandTotal: 0
    });
    var formData = [{
            type: FormItemTypes.ContainerItem,
            name: 'Header',
            value: null,
            label: '',
            display: 'flex',
            columnSize: 12,
            justifyContent: 'space-between',
            elements: [{
                    type: FormItemTypes.IconButton,
                    name: "",
                    children: /*#__PURE__*/ React.createElement("img", {
                        src: SavedSuccessGreenTickCircle,
                        alt: "",
                        loading: "lazy"
                    }),
                    columnSize: 0,
                    sx: {
                        height: '20px',
                        width: '48px',
                        mt: '10px',
                        color: 'secondary.600'
                    }
                }, {
                    type: FormItemTypes.IconButton,
                    name: '',
                    children: /*#__PURE__*/ React.createElement(CloseIcon, {
                        color: "text.secondary",
                        height: '12px',
                        width: '12px'
                    }),
                    columnSize: 0,
                    onClick: function () {
                        onClose(false);
                    },
                    sx: {
                        padding: '12px'
                    }
                }]
        }, {
            type: FormItemTypes.ContainerItem,
            name: '',
            label: '',
            value: null,
            mt: '20px',
            elements: [{
                    type: FormItemTypes.Typography,
                    name: '',
                    label: '',
                    value: null,
                    children: 'Saved successfully!',
                    fontSize: "xl",
                    fontWeight: 'strong',
                    columnSize: 12
                }, {
                    type: FormItemTypes.Typography,
                    name: '',
                    label: '',
                    value: null,
                    children: "Job card no:",
                    color: 'secondary.500',
                    fontSize: 'base',
                    fontWeight: 'normal',
                    columnSize: 0
                }, {
                    type: FormItemTypes.Typography,
                    name: '',
                    label: '',
                    value: null,
                    fontSize: 'base',
                    fontWeight: 'medium',
                    children: (_crud$JobCardInvoices = crud[JobCardInvoicesKeys === null || JobCardInvoicesKeys === void 0 ? void 0 : JobCardInvoicesKeys.GeneralTabJobCardDetails]) === null || _crud$JobCardInvoices === void 0 || (_crud$JobCardInvoices = _crud$JobCardInvoices.data) === null || _crud$JobCardInvoices === void 0 ? void 0 : _crud$JobCardInvoices.JobCardNo,
                    columnSize: 0
                }],
            columnSize: 12
        }, {
            type: FormItemTypes.Box,
            name: '',
            display: 'flex',
            flexDirection: 'column',
            gap: '12px',
            columnSize: 12,
            borderRadius: '8px',
            sx: {
                border: "1px solid",
                borderColor: 'secondary.200',
                bgcolor: 'secondary.50'
            },
            padding: '12px',
            elements: [{
                    type: FormItemTypes.Typography,
                    name: '',
                    label: 'Invoice Summary',
                    value: '',
                    labelTypographyProps: {
                        mb: 0,
                        noWrap: true,
                        fontSize: 'base',
                        fontWeight: 'medium',
                        color: 'secondary.900'
                    },
                    columnSize: 0
                }, {
                    type: FormItemTypes.Divider,
                    name: '',
                    value: null,
                    label: '',
                    columnSize: 12
                }, {
                    type: FormItemTypes.Typography,
                    name: 'PaidAmount',
                    label: 'Paid amount',
                    value: totals === null || totals === void 0 ? void 0 : totals.PaidAmount.toFixed(2),
                    containerProps: {
                        display: 'inline-flex',
                        justifyContent: 'space-between',
                        alignItems: 'baseline',
                        gap: 1
                    },
                    labelTypographyProps: {
                        mb: 0,
                        noWrap: true,
                        fontWeight: 'medium',
                        fontSize: 'sm'
                    },
                    fontWeight: 'normal',
                    fontSize: 'base',
                    columnSize: 0
                }, {
                    type: FormItemTypes.Typography,
                    name: 'ClaimAmount',
                    label: 'Claim amount',
                    value: totals === null || totals === void 0 ? void 0 : totals.ClaimAmount.toFixed(2),
                    containerProps: {
                        display: 'inline-flex',
                        justifyContent: 'space-between',
                        alignItems: 'baseline',
                        gap: 1
                    },
                    labelTypographyProps: {
                        mb: 0,
                        noWrap: true,
                        fontWeight: 'medium',
                        fontSize: 'sm'
                    },
                    fontWeight: 'normal',
                    fontSize: 'base',
                    columnSize: 0
                }, {
                    type: FormItemTypes.Typography,
                    name: 'ExpenseAmount',
                    label: 'Expense amount',
                    value: totals === null || totals === void 0 ? void 0 : totals.ExpenseAmount.toFixed(2),
                    containerProps: {
                        display: 'inline-flex',
                        justifyContent: 'space-between',
                        alignItems: 'baseline',
                        gap: 1
                    },
                    labelTypographyProps: {
                        mb: 0,
                        noWrap: true,
                        fontWeight: 'medium',
                        fontSize: 'sm'
                    },
                    fontWeight: 'normal',
                    fontSize: 'base',
                    columnSize: 0
                }, {
                    type: FormItemTypes.Typography,
                    name: 'TotalDiscount',
                    label: 'Total discount',
                    value: totals === null || totals === void 0 || (_totals$TotalDiscount = totals.TotalDiscount) === null || _totals$TotalDiscount === void 0 ? void 0 : _totals$TotalDiscount.toFixed(2),
                    containerProps: {
                        display: 'inline-flex',
                        justifyContent: 'space-between',
                        alignItems: 'baseline',
                        gap: 1
                    },
                    labelTypographyProps: {
                        mb: 0,
                        noWrap: true,
                        fontWeight: 'medium',
                        fontSize: 'sm'
                    },
                    fontWeight: 'normal',
                    fontSize: 'base',
                    columnSize: 0
                }, {
                    type: FormItemTypes.Typography,
                    name: 'TotalTax',
                    label: 'Total tax',
                    value: totals === null || totals === void 0 ? void 0 : totals.TotalTax.toFixed(2),
                    containerProps: {
                        display: 'inline-flex',
                        justifyContent: 'space-between',
                        alignItems: 'baseline',
                        gap: 1
                    },
                    labelTypographyProps: {
                        mb: 0,
                        noWrap: true,
                        fontWeight: 'medium',
                        fontSize: 'sm'
                    },
                    fontWeight: 'normal',
                    fontSize: 'base',
                    columnSize: 0
                }, {
                    type: FormItemTypes.Divider,
                    name: '',
                    value: null,
                    label: '',
                    columnSize: 12
                }, {
                    type: FormItemTypes.Typography,
                    name: 'GrandTotal',
                    label: 'Net payable amount',
                    value: totals === null || totals === void 0 ? void 0 : totals.GrandTotal.toFixed(2),
                    containerProps: {
                        display: 'inline-flex',
                        justifyContent: 'space-between',
                        alignItems: 'baseline',
                        gap: 1
                    },
                    labelTypographyProps: {
                        mb: 0,
                        noWrap: true,
                        fontSize: 'base',
                        fontWeight: 'medium',
                        color: 'secondary.900'
                    },
                    fontWeight: 'strong',
                    fontSize: 'base',
                    columnSize: 0
                }]
        }, {
            type: FormItemTypes.ContainerItem,
            name: "",
            label: "",
            value: null,
            columnSize: 12,
            spacing: 0,
            padding: '0px 0px 24px 24px',
            gap: '12px',
            justifyContent: "center",
            elements: [{
                    type: FormItemTypes.Button,
                    name: '',
                    children: 'Go to homepage',
                    xs: 6.5,
                    sm: 6,
                    md: 8,
                    lg: 8,
                    variant: 'contained',
                    fullWidth: true,
                    color: 'primary',
                    sx: {
                        fontSize: 'lg',
                        fontWeight: 'medium'
                    },
                    onClick: function () {
                        onClose('goHome');
                    }
                }, {
                    type: FormItemTypes.Button,
                    name: "",
                    children: /*#__PURE__*/ React.createElement(PrintSvgIcon, null),
                    columnSize: 0,
                    variant: "outlined",
                    color: 'secondary'
                }, {
                    type: FormItemTypes.Button,
                    name: '',
                    children: /*#__PURE__*/ React.createElement(ShareLineSvgIcon, null),
                    columnSize: 0,
                    variant: 'outlined',
                    color: 'secondary'
                }]
        }];
    return /*#__PURE__*/ React.createElement(Stack, {
        sx: {
            p: 3
        }
    }, /*#__PURE__*/ React.createElement(DynamicFormBuilderContainer, {
        getFormAPI: function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, ({
                        data: data,
                        success: true
                    })];
            });
        }); },
        formData: formData,
        mode: "edit"
    }));
};
